// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingDecisionEntity from './entities/meeting-decision.json';
import meetingDecisionMenu from '../pages/meeting-decision/menu.json';
import meetingDecisionFullForm from '../pages/meeting-decision/forms/full.json';
import meetingDecisionContextForm from '../pages/meeting-decision/forms/context.json';
import meetingDecisionMiniForm from '../pages/meeting-decision/forms/mini.json';
import meetingDecisionLookupForm from '../pages/meeting-decision/forms/lookup.json';
import meetingDecisionTableView from '../pages/meeting-decision/views/table.json';
import meetingDecisionCardsView from '../pages/meeting-decision/views/cards.json';
import meetingDecisionCalendarView from '../pages/meeting-decision/views/calendar.json';
import meetingDecisionDashboardView from '../pages/meeting-decision/views/dashboard.json';

/** Тип запису «Рішення засідання» зі сторінками пакета: меню, форми та подання з pages/meeting-decision/. */
export const meetingDecisionDefinition: IRecordTypeDefinition = {
  ...meetingDecisionEntity,
  views: assembleViewSet({
      table: meetingDecisionTableView,
      cards: meetingDecisionCardsView,
      calendar: meetingDecisionCalendarView,
      dashboard: meetingDecisionDashboardView,
  }),
  form: meetingDecisionFullForm,
  forms: { full: meetingDecisionFullForm, context: meetingDecisionContextForm, mini: meetingDecisionMiniForm, lookup: meetingDecisionLookupForm },
  menu: meetingDecisionMenu,
} as IRecordTypeDefinition;
